import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs';
import { AuthTokenService } from '../services/auth-token.service';
import { AuthService } from '../services/auth.service';
import { getAuthErrorReason } from '../auth-error/auth-error.component';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  template: '<p role="status">{{ statusMessage }}</p>'
})
export class AuthCallbackComponent implements OnInit {
  statusMessage = 'Signing you in...';

  constructor(
    private readonly authTokenService: AuthTokenService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  /**
   * Completes REM's PKCE exchange and restores the requested internal route.
   */
  ngOnInit(): void {
    console.log('[REM flow] AuthCallbackComponent.ngOnInit');
    const returnUrl = this.authTokenService.getPendingReturnUrl();

    this.authTokenService.handleCallback()
      .pipe(switchMap(() => this.authService.getCurrentUser()))
      .subscribe({
        next: () => {
          this.authTokenService.resetLoginAttempts();
          const destination = this.resolveDestination(returnUrl);
          console.log('[REM flow] AuthCallbackComponent: navigating to', destination);
          void this.router.navigateByUrl(destination);
        },
        error: (error) => {
          console.error('[REM flow] AuthCallbackComponent: authentication failed', error);
          const reason = getAuthErrorReason(error);
          void this.router.navigate(['/auth/error'], { queryParams: { reason } });
        }
      });
  }

  private resolveDestination(returnUrl: string): string {
    if (returnUrl !== '/') {
      return returnUrl;
    }

    return this.authService.getCurrentContextSync()?.role === 'nsc'
      ? '/nsc/dashboard'
      : '/dealer/dashboard';
  }
}